import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'formik';

import FieldWrapper from './FieldWrapper';

import fieldBase from '../theme/fieldBase';

const Input = styled.textarea`
  ${fieldBase}
  resize: vertical;
  line-height: 1.4;

  ${props =>
    props.modifiers.error &&
    `
    border-color: ${props.theme.colors.red500};
  `}

  ${props =>
    props.modifiers.small &&
    `
    padding: 9px 14px 8px;
    font-size: ${props.theme.fontSizes.small};
  `}
`;

function TextAreaField({
  name,
  hintText,
  disabled,
  readOnly,
  label,
  id,
  small,
  ...props
}) {
  return (
    <Field
      name={name}
      render={({ field, form: { errors, touched, submitCount } }) => {
        const errorMessage =
          ((touched && touched[field.name]) || submitCount > 0) &&
          errors &&
          errors[field.name];

        return (
          <FieldWrapper
            errorMessage={errorMessage}
            name={name}
            label={label}
            hintText={hintText}
            {...props}
          >
            <Input
              name={name}
              disabled={disabled}
              readOnly={readOnly}
              rows="10"
              id={id}
              modifiers={{ error: !!errorMessage, small }}
              {...props}
              {...field}
            >
              {field.value}
            </Input>
          </FieldWrapper>
        );
      }}
    />
  );
}

TextAreaField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  hintText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  small: PropTypes.bool,
};

TextAreaField.defaultProps = {
  disabled: false,
  hintText: null,
  readOnly: false,
  small: false,
};

export default TextAreaField;
